import { render, staticRenderFns } from "./EchartsHorizontalHistogram.vue?vue&type=template&id=0b3f2a5c&scoped=true"
import script from "./EchartsHorizontalHistogram.vue?vue&type=script&lang=js"
export * from "./EchartsHorizontalHistogram.vue?vue&type=script&lang=js"
import style0 from "./EchartsHorizontalHistogram.vue?vue&type=style&index=0&id=0b3f2a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f2a5c",
  null
  
)

export default component.exports